<div class="flex gap-4">
  <div class="w-1/3">
    <form [formGroup]="valueForm">
      <app-input-group>
        <label appLabel>{{ 'common.date.start' | translate }}</label>
        <input appInputDate formControlName="start" />
      </app-input-group>

      <app-input-group>
        <label appLabel>{{ 'common.date.end' | translate }}</label>
        <input appInputDate formControlName="end" />
      </app-input-group>

      <app-input-group>
        <label appLabel>{{ 'meteringpoint.timeseries.submit.periodusage' | translate }}</label>
        <input type="number"
               appInput
               formControlName="periodUsage"
        />
      </app-input-group>
    </form>

    <form [formGroup]="form">
      <app-input-group>
        <label appLabel>{{ 'meteringpoint.timeseries.submit.quantityquality' | translate }}</label>
        <select appSelect formControlName="quantityQuality" [collection]="quantityQuality">
        </select>
      </app-input-group>
      
      <app-input-group>
        <label appLabel>{{ 'meteringpoint.timeseries.submit.wantslocked' | translate }}</label>
        <select appSelect formControlName="wantsDataLocked">
          <option [value]="false">{{ 'common.no' | translate }}</option>
          <option [value]="true">{{ 'common.yes' | translate }}</option>
        </select>
      </app-input-group>
    </form>
    <div>
      <button
        appButton
        (click)="estimateValues()"
      >
        Estimer værdier
      </button>
    </div>
  </div>
  <div class="w-2/3 border-l border-gray-200 pl-4 relative">
    <form [formGroup]="intervalForm">
    @if (isEstimating) {
      <!-- Loading Overlay -->
      <div class="absolute top-0 left-0 right-0 bottom-0 bg-white bg-opacity-75 flex items-center justify-center z-10">
        <div class="text-center sticky top-1/2">
          <div class="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
          <p class="mt-2 text-primary">{{ 'common.loading' | translate }}</p>
        </div>
      </div>
    }
    <table class="bg-gray-100 dark:bg-dark-hover border-collapse table-fixed w-full overflow-hidden rounded-t-md">
        <thead>
        <tr>
          <th class="w-1/4 bg-gray-100 dark:bg-dark-hover px-2 py-1 rounded-t text-sm text-left font-normal text-primary dark:text-dark-text border-slate-200 dark:border-dark-border first-of-type:border-l border-r border-b border-t">Interval</th>
          @for (col of columns; track col) {
            <th class="bg-gray-100 dark:bg-dark-hover px-2 py-1 rounded-t text-sm text-left font-normal text-primary dark:text-dark-text border-slate-200 dark:border-dark-border first-of-type:border-l border-r border-b border-t">{{ col }}</th>
          }
        </tr>
        </thead>
        <tbody>
        @for (item of intervalArray; track item; let i = $index) {
          @if (i % 24 === 0) {
            <tr class="bg-gray-50 dark:bg-dark-hover">
              <td [attr.colspan]="columns.length + 1" class="text-primary dark:text-dark-text font-semibold text-sm py-2 px-2 border-slate-200 dark:border-dark-border first-of-type:border-l border-r border-b text-center">
                {{ calculateDateFromDayIndex(i / 24) | date:'dd/MM/yyyy' }}
              </td>
            </tr>
          }
          <tr class="odd:bg-white dark:odd:bg-dark-card even:bg-none">
            <td class="text-primary dark:text-dark-text font-normal text-sm py-1 px-2 border-slate-200 dark:border-dark-border first-of-type:border-l truncate border-r border-b">
              {{ (i % 24) < 10 ? '0' + (i % 24) : (i % 24) }} - {{ (i % 24) + 1 < 10 ? '0' + ((i % 24) + 1) : (i % 24) + 1 }}
            </td>
            @for (col of columns; track col; let j = $index) {
              <td class="text-primary dark:text-dark-text py-1 px-2 border-slate-200 dark:border-dark-border first-of-type:border-l truncate border-r border-b">
                <input type="number" class="!min-w-12" appInput step="0.1" [formControlName]="formatFormControlName(item[j])" />
              </td>
            }
          </tr>
        }
        </tbody>
      </table>
      <div>
        <a href="#" class="flex underline text-gray-400 text-sm py-4" (click)="$event.preventDefault(); clearValues()">{{ 'meteringpoint.timeseries.submit.clearintervals' | translate }}</a>
      </div>

    </form>
  </div>
</div>
